import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const rolePermissionList = async (payload?: any, signal?: any) => {
    const uri = API.RolePermission.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};

export const permissionList = async (payload?: any, signal?: any) => {
    const uri = API.RolePermission.listPermission + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};

export const createRolePermission = async (payload?: any) => {
    const uri = API.RolePermission.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
